import { ContentWordLimitKeys, Context, SubType } from '@/types';
export const ToneOptions = [
    {
        label: 'generateContentModal.writingTonePlaceholder',
        value: '',
        disable: true,
    },
    {
        label: 'generateContentModal.writingToneOptions.funny',
        value: 'funny',
    },
    {
        label: 'generateContentModal.writingToneOptions.casual',
        value: 'casual',
    },
    {
        label: 'generateContentModal.writingToneOptions.excited',
        value: 'excited',
    },
    {
        label: 'generateContentModal.writingToneOptions.professional',
        value: 'professional',
    },
    {
        label: 'generateContentModal.writingToneOptions.witty',
        value: 'witty',
    },
    {
        label: 'generateContentModal.writingToneOptions.sarcastic',
        value: 'sarcastic',
    },
    {
        label: 'generateContentModal.writingToneOptions.feminine',
        value: 'feminine',
    },
    {
        label: 'generateContentModal.writingToneOptions.masculine',
        value: 'masculine',
    },
    {
        label: 'generateContentModal.writingToneOptions.bold',
        value: 'bold',
    },
    {
        label: 'generateContentModal.writingToneOptions.dramatic',
        value: 'dramatic',
    },
    {
        label: 'generateContentModal.writingToneOptions.grumpy',
        value: 'grumpy',
    },
    {
        label: 'generateContentModal.writingToneOptions.secretive',
        value: 'secretive',
    },
    {
        label: 'generateContentModal.writingToneOptions.respectful',
        value: 'respectful',
    },
    {
        label: 'generateContentModal.writingToneOptions.persuasive',
        value: 'persuasive',
    },
];
export const SubTypeOptions = [
    {
        label: 'generateContentModal.typePlaceholder',
        value: '',
        disable: true,
    },
    {
        label: 'generateContentModal.typeOptions.outline',
        value: SubType.OUTLINE,
    },
    {
        label: 'generateContentModal.typeOptions.introduction',
        value: SubType.INTRO,
    },
    {
        label: 'generateContentModal.typeOptions.section',
        value: SubType.SECTION,
    },
];
export const ContextOptions = [
    {
        label: 'generateContentModal.contextPlaceholder',
        value: '',
        disable: true,
    },
    {
        label: 'generateContentModal.contextOptions.promotional',
        value: Context.PROMOTIONAL,
    },
    {
        label: 'generateContentModal.contextOptions.introduction',
        value: Context.INTRODUCTION,
    },
    {
        label: 'generateContentModal.contextOptions.couponDiscount',
        value: Context.COUPON_DISCOUNT,
    },
    {
        label: 'generateContentModal.contextOptions.recurringNewsletter',
        value: Context.RECURRING_NEWSLETTER,
    },
    {
        label: 'generateContentModal.contextOptions.testimonial',
        value: Context.TESTIMONIAL,
    },
    {
        label: 'generateContentModal.contextOptions.coldOutreach',
        value: Context.COLD_OUTREACH,
    },
    {
        label: 'generateContentModal.contextOptions.contentGiveaway',
        value: Context.CONTENT_GIVEAWAY_EMAIL,
    },
    {
        label: 'generateContentModal.contextOptions.other',
        value: Context.OTHER,
    },
];
export const ContentWordLimitOptions = [
    {
        label: 'generateContentModal.smallContent',
        value: ContentWordLimitKeys.SMALL,
    },
    {
        label: 'generateContentModal.mediumContent',
        value: ContentWordLimitKeys.MEDIUM,
    },
    {
        label: 'generateContentModal.largeContent',
        value: ContentWordLimitKeys.LARGE,
    },
    {
        label: 'generateContentModal.customContentLength',
        value: ContentWordLimitKeys.CUSTOM,
    },
];
